export default "__VITE_ASSET__CSWkAE69__"